import React, { ReactNode } from 'react';

import { Button, InfoBox, Chip } from '@infoods/lifebase-ui';
import { useToggle } from 'react-use';

import classes from './TaxInfoBlock.module.scss';

import { SetUpTaxModal } from './SetUpTaxModal/SetUpTaxModal';
import { ActivationStatusChip } from '../ActivationStatusChip/ActivationStatusChip';
import { TaxRateInfo } from '../../interfaces/tax';

type TaxInfoBlockProps = {
  taxRateInfo: TaxRateInfo | null | undefined;
  isActive: boolean | undefined;
  description: ReactNode;
  formulaText?: string;
  onSetTaxRate: (taxRate: number) => void;
};

const DEFAULT_FORMULA_TEXT =
  'Total Subscription Price = Subscription Price + Entity Tax, %';

const TaxInfoBlock = ({
  taxRateInfo,
  description,
  formulaText = DEFAULT_FORMULA_TEXT,
  isActive,
  onSetTaxRate,
}: TaxInfoBlockProps) => {
  const [isShowSetTaxModal, toggleShowSetTaxModal] = useToggle(false);

  const isTaxSet = taxRateInfo?.id;
  const CompleteSetupChip = <Chip label="Complete setup" size="small" color="error" />;

  return (
    <>
      <InfoBox
        title="Entity Tax"
        adornment={!isTaxSet && CompleteSetupChip}
        contentClassName={classes.box}
      >
        <div className={classes.textBox}>
          <div className={classes.titleBox}>
            <h5 className={classes.title}>
              {isTaxSet ? (
                <>
                  <span>Sales Tax:</span>
                  <span className="private-info">{taxRateInfo.taxRatePercent}%</span>
                </>
              ) : (
                'No Sales Tax'
              )}
            </h5>
            <ActivationStatusChip active={isActive} />
          </div>
          <p className={classes.description}>{description}</p>
          <p className={classes.description}>{formulaText}</p>
        </div>
        <Button variant="outlined" size="small" onClick={toggleShowSetTaxModal}>
          Set up tax
        </Button>
      </InfoBox>
      {isShowSetTaxModal && (
        <SetUpTaxModal onClose={toggleShowSetTaxModal} onSubmit={onSetTaxRate} />
      )}
    </>
  );
};

export { TaxInfoBlock };
